import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (GET SMTP settings) -----------
export const fetchSmtpSettings = createAsyncThunk(
  "smtpSettings/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/dashboard/general-settings/smtp-settings");
      return response.data.data.settings;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const smtpSettingsSlicer = createSlice({
  name: "smtpSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSmtpSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSmtpSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSmtpSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSmtpSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSmtpSettingsState } = smtpSettingsSlicer.actions;
export default smtpSettingsSlicer.reducer;